import type { Action } from '@reduxjs/toolkit';
import { configureStore } from '@reduxjs/toolkit';
import type { TypedUseSelectorHook } from 'react-redux';
import {
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector
} from 'react-redux';
import type { ThunkAction } from 'redux-thunk';
import { BannerServiceDetail } from 'src/services/Banner-services';
import { contentServiceDetail } from 'src/services/Content-services';
import { CurrencyServiceDetail } from 'src/services/Currency-services';
import { reviewRatingService } from 'src/services/Review-services';
import { fileUploadServices } from 'src/services/tourism-classified/file-upload-services';
import { vendorServiceDetail } from 'src/services/tourism-classified/package-services';
import { PermissionServices } from 'src/services/user-management/permission-services';
import { roleServices } from 'src/services/user-management/role-services';
import { userServices } from 'src/services/user-management/user-services';
import { vendorApprovalServices } from 'src/services/vendor-management/vendor-services';
import { referralServices } from 'src/services/referral-services';
import bannerPageReducer from 'src/slices/Banner';
import { cityServices } from '../services/tourism-classified/city-services/index';
import { enquiryDetail } from '../services/tourism-classified/enquiry-detail-services/index';
import { enumServices } from '../services/user-management/enum-services/index';
import { sosServices } from '../services/tourism-classified/sos-services/index';
import { systemConfigServices } from '../services/tourism-classified/system-config-services/index';
import enumReducer from '../slices/enums';
import rootReducer from './rootReducer';

const store = configureStore({
  reducer: {
    ...rootReducer,
    enum: enumReducer,
      topbanner: bannerPageReducer,
    [userServices.reducerPath]: userServices.reducer,
    [roleServices.reducerPath]: roleServices.reducer,
    [PermissionServices.reducerPath]: PermissionServices.reducer,
    [vendorApprovalServices.reducerPath]: vendorApprovalServices.reducer,
    [fileUploadServices.reducerPath]: fileUploadServices.reducer,
    [cityServices.reducerPath]: cityServices.reducer,
    [vendorServiceDetail.reducerPath]: vendorServiceDetail.reducer,
    [enumServices.reducerPath]: enumServices.reducer,
    [enquiryDetail.reducerPath]: enquiryDetail.reducer,
    [BannerServiceDetail.reducerPath]: BannerServiceDetail.reducer,
    [contentServiceDetail.reducerPath]: contentServiceDetail.reducer,
    [reviewRatingService.reducerPath]: reviewRatingService.reducer,
    [CurrencyServiceDetail.reducerPath]: CurrencyServiceDetail.reducer,
    [referralServices.reducerPath]: referralServices.reducer,
    [sosServices.reducerPath]: sosServices.reducer,
    [systemConfigServices.reducerPath]: systemConfigServices.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
      .concat(userServices.middleware)
      .concat(roleServices.middleware)
      .concat(PermissionServices.middleware)
      .concat(vendorApprovalServices.middleware)
      .concat(fileUploadServices.middleware)
      .concat(cityServices.middleware)
      .concat(vendorServiceDetail.middleware)
      .concat(enumServices.middleware)
      .concat(BannerServiceDetail.middleware)
      .concat(contentServiceDetail.middleware)
      .concat(enquiryDetail.middleware)
      .concat(reviewRatingService.middleware)
      .concat(CurrencyServiceDetail.middleware)
      .concat(referralServices.middleware)
      .concat(sosServices.middleware)
      .concat(systemConfigServices.middleware),
  devTools: true
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, RootState, null, Action<string>>;
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;
export const useDispatch = () => useReduxDispatch<AppDispatch>();
export default store;